import {AppStore} from "../../desktop";
import {Position} from "../../models/Position";
import {PositionsActionTypes} from "./types";
import {TabsActionTypes} from "../tabs";

export const actionPositionFetchAll = () => {
	AppStore.dispatch({type: PositionsActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionPositionFetchAllCompleted = (positions: Position[]) => {
	AppStore.dispatch({type: PositionsActionTypes.FETCH_ALL_COMPLETED, payload: positions})
}

export const actionPositionFetch = (position: Position) => {
	AppStore.dispatch({type: PositionsActionTypes.FETCH_ONE_REQUEST, payload: position})
}

export const actionPositionFetchCompleted = (position: Position) => {
	AppStore.dispatch({type: PositionsActionTypes.FETCH_ONE_COMPLETED, payload: position})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: position})
}

export const actionPositionSave = (position: Position) => {
	AppStore.dispatch({type: PositionsActionTypes.SAVE_REQUEST, payload: position})
}

export const actionPositionSaveCompleted = (position: Position) => {
	AppStore.dispatch({type: PositionsActionTypes.SAVE_COMPLETED, payload: position})
}

export const actionPositionDelete = (position: Position) => {
	AppStore.dispatch({type: PositionsActionTypes.DELETE_REQUEST, payload: position})
}

export const actionPositionDeleteCompleted = (position: Position) => {
	AppStore.dispatch({type: PositionsActionTypes.DELETE_COMPLETED, payload: position})
}

export const actionDeletePositions = (positions: Position[]) => {
	AppStore.dispatch({type: PositionsActionTypes.DELETE_MULTIPLE_REQUEST, payload: positions})
}

export const actionDeletePositionsCompleted = (positions: Position[]) => {
	AppStore.dispatch({type: PositionsActionTypes.DELETE_MULTIPLE_COMPLETED, payload: positions})
}
